import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { AxiosCustomGet } from "../../components/axios/AxiosCustom";
import Config from "../../components/axios/Config";
import SwalToast from "../../components/helpers/SwalToast";
import httpclient from "../../components/httpclient";
import Title from "../../components/common/Title/Title";
import Breadcrumb from "../../components/common/Breadcrumb/Breadcrumb";
import { Modal, Button, Input } from "antd";
import "antd/dist/antd.css";
import "./styles.css";
import CustomTable from "../../components/common/Table/CustomTable";
import { filterIsUsed, initFilterInput, renderColumns } from "./constants";
import { TiUser } from "react-icons/ti";
import QRCode from "react-qr-code";
import TextInput from "../../components/common/TextInput/TextInput";
import MultipleSelect from "../../components/common/MultipleSelect/MultipleSelect";
import {
  AuthorizationList,
  CanAccess,
} from "../../components/template/authorization/Authorization";

const ListLabel = () => {
  const [totalLabel, setTotalLabel] = useState();
  const [records, setRecords] = useState([]);
  const [totalRecord, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(0);
  const [modalAdd, setModalAdd] = useState(false);
  const [modalPrint, setModalPrint] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checkAll, setCheckAll] = useState(false);
  const [tablePagination, setTablePagination] = useState({});
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [filterInput, setFilterInput] = useState(initFilterInput);
  const [filterUsedValue, setFilterUsedValue] = useState({
    label: "Semua",
    value: "",
  });

  useEffect(() => {
    if (filterInput.pageSize !== null) {
      getData();
    }
  }, [filterInput]);

  const handleSubmit = () => {
    setSubmitting(true);

    let data = {
      total: parseInt(totalLabel),
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}label`;
    httpclient
      .POST(url, data)
      .then((response) => {
        SwalToast.fire({
          icon: "success",
          title: response.data.message,
        });
        window.location.reload(false);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data.error);
          SwalToast.fire({
            icon: "error",
            title: error.response.data.error.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleCloseModal = () => {
    setModalAdd(false);
    setTotalLabel("");
  };

  const getData = () => {
    setLoading(true);
    let params = {
      is_used: filterInput.isUsed,
      code: filterInput.searchName,
      page: filterInput.page,
      size: parseInt(filterInput.pageSize),
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}label`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        params
      ),
      (response) => {
        setLoading(false);
        let data = [];
        response.data.data.items.forEach((value) => {
          data.push({
            ...value,
            is_checked: false,
          });
        });
        setTablePagination({
          current: response.data.data?.page,
          pageSize: response.data.data?.per_page,
          total: response.data.data?.total_item,
        });
        setRecords(data);
      },
      (error) => {
        setLoading(false);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleTableChange = (pagination, _, sorter) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      size: parseInt(pagination.pageSize),
    }));
  };

  const onCheck = (record) => {
    let temp = [...records];
    temp.find((value) => value.id === record.id).is_checked = !temp.find(
      (value) => value.id === record.id
    ).is_checked;
    setRecords(temp);
  };

  const onCheckAll = () => {
    setCheckAll(!checkAll);
    let temp = [...records];
    temp.forEach((value) => {
      value.is_checked = !checkAll;
    });
    setRecords(temp);
  };

  const handleEnter =
    (type = "enter") =>
    (event) => {
      const { name, value } = event.target;
      if (event.keyCode === 13 || type === "blur") {
        if (name === "pageSize" && value === "") {
          setFilterInput((prev) => ({
            ...prev,
            pageSize: value,
          }));
        }
        setFilterInput((prev) => ({
          ...prev,
          [name]: name === "pageSize" && value === "" ? 10 : value,
          page: 1,
        }));
      }
    };

  const handleTextInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "pageSize") {
      setFilterInput((prev) => ({
        ...prev,
        [name]: name === "pageSize" && value === "" ? null : value,
        page: 1,
      }));
    } else if (name === "name") {
      setFilterInput((prev) => ({
        ...prev,
        searchName: value,
      }));
    }
  };

  const handleSelectChange = (field, data) => {
    setFilterUsedValue({
      value: data.value,
      label: data.label,
    });
    setFilterInput((prev) => ({
      ...prev,
      isUsed: data.value,
      page: 1,
    }));
  };

  return (
    <>
      <div id="parent-printable">
        <div id="label-printable">
          {records.map((value) => (
            <>
              {value.is_checked && (
                <div className="rounded border-black text-center p-3 mb-3">
                  <img
                    src="/images/degadai-logo-black.png"
                    alt="Degadai Logo"
                    style={{ width: "50mm" }}
                  />
                  <div className="mt-2">
                    <QRCode value={value.label_code} size={170} />
                  </div>
                  <h4 className="mt-3 mb-0 font-weight-bold">
                    {value.label_code}
                  </h4>
                </div>
              )}
            </>
          ))}
        </div>
      </div>
      <div>
        <div className="px-3">
          <div
            className="py-4 d-flex justify-content-between"
            style={{ fontSize: "13px" }}
          >
            <div className="">
              <Title text={"Pengaturan Label"} />
              <Breadcrumb current={"Pengaturan Label"} />
            </div>
            <div
              style={{
                padding: 13,
                border: "1px solid #DCDCDC",
                borderRadius: 5,
                height: 50,
                width: 222,
              }}
            >
              <div
                style={{
                  fontSize: 18,
                  color: "#303030",
                }}
              >
                <TiUser
                  style={{ marginBottom: 5, fontSize: 24, color: "#D6D6D6" }}
                />
                <span style={{ fontWeight: 700 }}>{records.length}</span> Total
                Label
              </div>
            </div>
          </div>
          <div className="d-flex pt-3 align-items-center justify-content-between">
            <div className="d-flex col-6">
              <TextInput
                id={"pageSize"}
                label={"Tampilkan"}
                width={"20%"}
                handleEnter={handleEnter}
                handleChange={handleTextInputChange}
                value={filterInput.pageSize}
              />
              <div className="mx-2">
                <TextInput
                  id={"name"}
                  label={"Kode Label/No. SBG/No. Kwitansi:"}
                  width={"100%"}
                  placeholder={"Nama Produk"}
                  handleEnter={handleEnter}
                  handleChange={handleTextInputChange}
                  value={filterInput.searchName}
                />
              </div>

              <MultipleSelect
                className="ml-1"
                id={"isUsed"}
                label={"Filter"}
                width={"30%"}
                onSelectChange={handleSelectChange}
                options={filterIsUsed}
                value={filterUsedValue}
              />
            </div>

            <div className="mr-0">
              <CanAccess
                role={AuthorizationList.print_label}
                yes={
                  <button
                    className="ml-3 btn text-white font-weight-semi-bold"
                    style={{ backgroundColor: "#F5CB58" }}
                    onClick={() => setModalPrint(true)}
                  >
                    Cetak Label
                  </button>
                }
              />
              <CanAccess
                role={AuthorizationList.create_label}
                yes={
                  <button
                    className="ml-3 btn bgc-2C465C text-white font-weight-semi-bold"
                    onClick={() => setModalAdd(true)}
                  >
                    + Tambah Label
                  </button>
                }
              />
            </div>
          </div>
          <div style={{ marginTop: 12 }}>
            <CustomTable
              columns={renderColumns(onCheck, checkAll, onCheckAll)}
              data={records}
              loading={loading}
              pagination={tablePagination}
              handleTableChange={handleTableChange}
            />
          </div>
        </div>
      </div>

      <Modal
        className="modal-add"
        centered
        title={"Tambah Label"}
        visible={modalAdd}
        onOk={handleSubmit}
        onCancel={handleCloseModal}
        footer={[
          <Button
            onClick={handleCloseModal}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>,
          <Button
            type="submit"
            disabled={submitting}
            onClick={handleSubmit}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Simpan
          </Button>,
        ]}
      >
        <div className="d-flex align-items-center mt-2">
          <div style={{ flex: 1 }}>
            <div className="color-A6A6A6">Jumlah Label :</div>
          </div>
          <div style={{ flex: 2 }}>
            <Input
              style={{ height: 36 }}
              required
              type="number"
              className="form-control border-DCDCDC text-input"
              placeholder="Jumlah Label"
              value={totalLabel}
              onChange={(e) => setTotalLabel(e.target.value)}
            />
          </div>
        </div>
        <p className="mt-2 mb-0 text-center">
          Pastikan komputer Anda sudah terhubung dengan printer untuk mencetak
          label. 1 kertas A4 hanya memuat 9 label.
        </p>
      </Modal>

      <Modal
        className="modal-print"
        centered
        title={"Cetak Label"}
        visible={modalPrint}
        onCancel={() => setModalPrint(false)}
        footer={[
          <Button
            onClick={() => setModalPrint(false)}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>,
          <Button
            type="submit"
            disabled={submitting}
            onClick={() => window.print()}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Cetak Label
          </Button>,
        ]}
      >
        <p className="mt-2 mb-0 text-center">
          Pastikan komputer Anda sudah terhubung dengan printer untuk mencetak
          label.
        </p>
      </Modal>
    </>
  );
};

export default ListLabel;
